// extracted by mini-css-extract-plugin
export default {"UserMenuButton":"UserMenu_UserMenuButton__qBGig"};